/** Footer category link row (public site). */

export function getFooterItemTrekSlugs(item) {
  if (!item || typeof item !== 'object') return [];
  if (Array.isArray(item.trekSlugs) && item.trekSlugs.length) {
    return item.trekSlugs.map((s) => String(s).trim()).filter(Boolean);
  }
  const legacy = String(item.slug || '').trim();
  return legacy ? [legacy] : [];
}

export function normalizeFooterCategoryItem(item) {
  const label = String(item?.label || '').trim();
  const search = String(item?.search ?? '').trim();
  const trekSlugs = getFooterItemTrekSlugs(item);
  const out = {
    label,
    search: search || (trekSlugs.length ? '' : label)
  };
  if (trekSlugs.length) out.trekSlugs = trekSlugs;
  if (Array.isArray(item?.trekIds) && item.trekIds.length) {
    out.trekIds = item.trekIds.map((id) => String(id).trim()).filter(Boolean);
  }
  return out;
}

/** Where the footer link should navigate. */
export function footerCategoryItemHref(item) {
  const slugs = getFooterItemTrekSlugs(item);
  if (slugs.length === 1) {
    return `/events/${encodeURIComponent(slugs[0])}`;
  }
  if (slugs.length > 1) {
    return `/events?treks=${slugs.map((s) => encodeURIComponent(s)).join(',')}`;
  }
  const q = String(item?.search || item?.label || '').trim();
  return q ? `/events?search=${encodeURIComponent(q)}` : '/events';
}
